import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: {
            uid: '',
            displayName: '',
            photoURL: ''
        },
        listRefs: [],
        sharedListRefs: [],
        isMobile: true
    }
});